var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({staticClass:"button--square-icon",attrs:{"color":_vm.color,"depressed":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"size":_vm.iconSize,"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }